// extracted by mini-css-extract-plugin
module.exports = {"CallToActionObserver":"call-to-action-observer_CallToActionObserver__HM3NJ"};